import { useState } from "react"
import { useField } from "formik"

import { MeetingServicePriceListState, MeetingServicePriceListStatus, SelectedPriceListItem } from "../createOrderTypes"

export const useSelectPriceLists = (additionalFunction: () => void) => {
    const [showSelectPriceListsDialog, setShowSelectPriceListsDialog] = useState(false)
    const [, , helpers] = useField<MeetingServicePriceListState>("priceList")

    const handleSelectPriceList = (selected: SelectedPriceListItem) => {
        helpers.setValue({ item: selected, status: MeetingServicePriceListStatus.VALIDATING })

        setShowSelectPriceListsDialog(false)
        additionalFunction()
    }

    return { showSelectPriceListsDialog, setShowSelectPriceListsDialog, handleSelectPriceList }
}
